import { GET_ALERT_META_INFO_V4 } from '@nile/rmm/src/modules/alert-management/Graphql/alert';
import {
  GET_PATCH_DETAIL_VIEW_LIST_META_INFO,
  GET_PATCH_ASSET_DETAIL_LIST_VIEW_META_V2,
  GET_PATCH_LIST_VIEW_META_INFO_BY_CLASS_ID_AND_VIEW_ID
} from '@nile/rmm/src/modules/patch-management/Graphql/patch';
import { RMMClient } from '@nile/graphql';
import {
  GET_MONITORED_ASSET_META_INFO,
  GET_ASSET_GROUP_INFO_BY_CLASSID,
  GET_COMMUNITY_SCRIPT_VIEW_META,
  GET_ASSET_VIEW_META_INFO
} from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { GET_SCRIPTS_META_V2 } from '@nile/rmm/src/modules/scripts/Graphql';

const assetViewConfig = {
  api: GET_ASSET_VIEW_META_INFO,
  accessKey: 'getAssetViewConditionMetaInfo',
  client: RMMClient,
  defaultCondition: {
    joinOperator: 'AND',
    operands: [{ attribute: 'assetId', operator: 'isNotEmpty', value: '' }]
  }
};

const config = {
  alert: {
    api: GET_ALERT_META_INFO_V4,
    accessKey: 'getAlertViewMetaInfoV4',
    client: RMMClient,
    defaultCondition: {
      joinOperator: 'AND',
      operands: [{ attribute: 'id', operator: 'isNotEmpty', value: '' }]
    }
  },
  'asset-view': assetViewConfig,
  'client-asset-view': assetViewConfig,
  'portal-asset-view': assetViewConfig,
  'all-asset-view': {
    api: GET_MONITORED_ASSET_META_INFO,
    accessKey: 'getMonitoredAssetsMetaInfo',
    client: RMMClient,
    defaultCondition: {
      joinOperator: 'AND',
      operands: [{ attribute: 'assetId', operator: 'isNotEmpty', value: '' }]
    }
  },
  'asset-group': {
    api: GET_ASSET_GROUP_INFO_BY_CLASSID,
    accessKey: 'getAssetGroupMetaInfoByClassId',
    nestedAccessKey: 'AssetGroupViewMeta',
    client: RMMClient,
    defaultCondition: {
      joinOperator: 'AND',
      operands: [{ attribute: 'assetId', operator: 'isNotEmpty', value: '' }]
    }
  },
  patch: {
    api: GET_PATCH_DETAIL_VIEW_LIST_META_INFO,
    accessKey: 'getPatchDetailListViewMetaInfoV2',
    client: RMMClient,
    defaultCondition: {
      joinOperator: 'AND',
      operands: [{ attribute: 'patchId', operator: 'isNotEmpty', value: '' }]
    }
  },
  'patch-associated-asset': {
    api: GET_PATCH_ASSET_DETAIL_LIST_VIEW_META_V2,
    nestedAccessKey: 'listView',
    accessKey: 'getPatchAssetsDetailListViewMetaInfoV2',
    client: RMMClient,
    defaultCondition: {
      joinOperator: 'AND',
      operands: [{ attribute: 'patchId', operator: 'isNotEmpty', value: '' }]
    }
  },
  patchv3: {
    api: GET_PATCH_LIST_VIEW_META_INFO_BY_CLASS_ID_AND_VIEW_ID,
    accessKey: 'getPatchListViewMetaInfoByClassIdAndViewId',
    client: RMMClient,
    defaultCondition: {
      joinOperator: 'AND',
      operands: [{ attribute: 'patchId', operator: 'isNotEmpty', value: '' }]
    }
  },
  script: {
    api: GET_SCRIPTS_META_V2,
    accessKey: 'getScriptsMetaV2',
    nestedAccessKey: 'scriptViewsMeta',
    client: RMMClient,
    defaultCondition: {
      joinOperator: 'AND',
      operands: [{ attribute: 'scriptId', operator: 'isNotEmpty', value: '' }]
    }
  },
  'community-script': {
    api: GET_COMMUNITY_SCRIPT_VIEW_META,
    accessKey: 'getCommunityScriptViewMetaInfo',
    client: RMMClient,
    defaultCondition: {
      joinOperator: 'AND',
      operands: [{ attribute: 'scriptId', operator: 'isNotEmpty', value: '' }]
    }
  }
};

export { config };
